<template>
  <div>
    <div class="block__container block__container--compact">
      <step-header-component :headerText="headerText" :subHeaderText="subHeaderText"></step-header-component>
    </div>
    <div class="block--primary">
      <carousel></carousel>
    </div>
    <div class="block__container block__container--compact">
      <progress-bar
        :hideForwardNavigation="hideForwardNavigation"
        :hideBackwardNavigation="hideBackwardNavigation"
        :validationScope="validationScope"
        :progressBarValue=40>
      </progress-bar>
      <vehicle-customisation :validationScope="validationScope"></vehicle-customisation>
      <next-button :validationScope="validationScope"></next-button>
    </div>
    <div class="block--center">
      <pricing-data></pricing-data>
    </div>
    <div class="block--tertiary block--center">
      <div class="block__container block__container--compact">
        <testimonials></testimonials>
      </div>
    </div>
    <div class="block__container">
      <start-again></start-again>
    </div>
    <div class="block--secondary block--center">
      <div class="block__container">
        <accordion></accordion>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';
import StepHeaderComponent from '../general/StepHeaderComponent.vue';
import CarouselComponent from '../general/CarouselComponent.vue';
import ProgressBarComponent from '../general/ProgressBarComponent.vue';
import VehicleCustomisationComponent from '../vehicle/VehicleCustomisationComponent.vue';
import NextButtonComponent from '../navigation/NextButtonComponent.vue';
import PricingDataComponent from '../pricing/PricingDataComponent.vue';
import TestimonialsComponent from '../general/TestimonialsComponent.vue';
import StartAgainComponent from '../navigation/StartAgainComponent.vue';
import AccordionComponent from '../general/AccordionComponent.vue';

@Component({
  components: {
  'step-header-component': StepHeaderComponent,
  carousel: CarouselComponent,
  'progress-bar': ProgressBarComponent,
  'vehicle-customisation': VehicleCustomisationComponent,
  'next-button': NextButtonComponent,
  'pricing-data': PricingDataComponent,
  testimonials: TestimonialsComponent,
  'start-again': StartAgainComponent,
  accordion: AccordionComponent
  }
  })

export default class ModelOptionsStepComponent extends Vue {
  @Prop({ default: 'Model Options' })
  public headerText!: string;

  @Prop({ default: 'Choose the best combination of model and engine for you' })
  public subHeaderText!: string;

  @Prop({ default: null })
  public validationScope!: string;

  @Prop({ default: false })
  public hideForwardNavigation!: boolean;

  @Prop({ default: false })
  public hideBackwardNavigation!: boolean;
}
</script>
